export default {"src":"/_next/static/media/growth-sm.mono.389fea37.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};